import React from 'react';
import { AlertTriangle, CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ReadOnlyBannerProps {
  plan: 'expired' | 'cancelled';
  trialDaysLeft?: number | null;
}

export const ReadOnlyBanner: React.FC<ReadOnlyBannerProps> = ({ plan, trialDaysLeft }) => {
  const navigate = useNavigate();

  const message =
    plan === 'expired'
      ? 'Your trial has expired. Your data is preserved — subscribe to regain full access.'
      : 'Your subscription was cancelled. Data is preserved for 90 days.';

  return (
    <div className="bg-red-50 border-b border-red-200 px-4 py-3 flex items-center justify-between gap-3 sticky top-0 z-40">
      <div className="flex items-center gap-2 text-red-800 text-sm font-medium">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <span>{message}</span>
      </div>
      <button
        onClick={() => navigate('/admin/settings?tab=billing')}
        className="flex items-center gap-1.5 px-4 py-1.5 bg-red-600 text-white text-sm font-semibold rounded-lg hover:bg-red-700 transition-colors flex-shrink-0"
      >
        <CreditCard className="w-4 h-4" />
        Subscribe Now
      </button>
    </div>
  );
};
